import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    elevation: 4,
    class: "rounded-lg"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _createTextVNode("Documents")
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    label: "HRN",
                    hint: "Hospital Registration Number",
                    variant: "outlined",
                    density: "comfortable",
                    color: "primary"
                  }),
                  _createVNode(_component_v_text_field, {
                    label: "Document Number",
                    hint: "Documents",
                    variant: "outlined",
                    density: "comfortable",
                    color: "primary"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_autocomplete, {
                    label: "Document Type",
                    items: _ctx.documentType,
                    variant: "outlined",
                    density: "comfortable",
                    color: "primary"
                  }, null, 8, ["items"]),
                  _createVNode(_component_v_text_field, {
                    label: "Document Expiry",
                    hint: "Expiry Date",
                    variant: "outlined",
                    density: "comfortable",
                    type: "date",
                    color: "primary"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}